import {
  INQUIRY_GET_EXCHANAGE_RATE,
  INQUIRY_UPDATE_EXCHANGE_RATE,
  INQUIRY_CREATE_INQUERY,
  INQUIRY_UPDATE_INQUERY,
  INQUIRY_SEARCH_INQUIRY_FOR_FF,
  INQUIRY_SEND_INQUIRY,
  SEND_BULK_INQUIRY,
  INQUIRY_UPDATE_DEADLINE,
  BULK_INQUIRY_DEADLINE_UPDATE,
  INQUIRY_FETCH_INQUIRY_DETAILS_FOR_FF,
  INQUIRY_SEND_BID_FOR_INQUIRY,
  INQUIRY_CREATE_BID_FOR_INQUIRY,
  INQUIRY_CONFIRM_BID_FOR_INQUIRY,
  INQUIRY_DECLINE_BID_FOR_INQUIRY,
  INQUIRY_UPDATE_BID_FOR_INQUIRY,
  INQUIRY_GET_MASTER_DATA,
  INQUIRY_SEARCH_INQUIRY_FOR_SHIPPER,
  INQUIRY_FETCH_ALL_FF_INQUIRIES,
  INQUIRY_FETCH_ALL_SHIPPER_INQUIRIES,
  INQUIRY_GET_BID_MASTER_FOR_INQUIRY,
  INQUIRY_FETCH_STATUS_WISE_COUNT_FOR_SHIPPER_INQUIRIES,
  INQUIRY_FETCH_STATUS_WISE_COUNT_FOR_FF_INQUIRIES,
  INQUIRY_FETCH_RECENT_INQUIRY_BIDS_FOR_FF,
  INQUIRY_FETCH_ALL_BIDS_SHIPPER_INQUIRY,
  INQUIRY_FETCH_ALL_BIDS_FF_INQUIRY,
  INQUIRY_FF_VIEW_BREAKDOWN,
  INQUIRY_DELETE_INQUIRY,
  INQUIRY_FETCH_INQUIRY_SHIPPER_DETAILS,
  INQUIRY_SHIPPER_VIEW_BREAKDOWN,
  INQUIRY_FETCH_BID_CHARGES,
  GET_INQUIRY_DETAILS_FOR_BID,
  INQUIRY_DELETE_BID,
  INQUIRY_GET_BID_RANKS_FOR_SHIPPER,
  INQUIRY_GET_BID_RANKS_FOR_FF,
  INQUIRY_DOWNLOAD_BIDS_SHIPPER,
  INQUIRY_DOWNLOAD_BIDS_FF,
  GET_S3_UPLOAD_LINKS,
  FETCH_INQUIRY_SUMMARY_FOR_SHIPPER,
  INQUIRY_EXETEND_DEADLINE_FOR_BID,
  INQUIRY_MIS_REPORTS,
  INQUIRY_DELETE_BID_FOR_SHIPPER,
  VIEW_BREAKDOWN_DOWNLOAD,
  FETCH_BULK_BID_HEADER_MAPPING,
  INQUIRY_UPLOAD_BULK_BIDS,
  DOWNLOAD_SAMPLE_INQUIRY,
  BULK_INQUIRY_CREATION_ENDPOINT,
  DOWNLOAD_SAMPLE_BIDS,
  FETCH_LINKED_FFS_FOR_INQUIRY,
  INQUIRY_CREATE_BID_SHIPPER,
  DOWNLOAD_SAMPLE_BIDS_SHIPPER,
  INQUIRY_UPLOAD_BULK_BIDS_SHIPPER,
  GET_ALL_CHARGES_FOR_BULK_BIDS_UPLOAD,
  INQUIRY_SEARCH_INTERNAL_REFERENCE,
  RESET_REFERENCE_RATE_NOTIFICATION_ROUTE,
  INQUIRY_BID_REVISION_FF,
  INQUIRY_BID_REVISION_SHIPPER,
  EDIT_ACCESS_INQUIRY_DETAILS,
  FETCH_LOWEST_BID_ROUTE,
  EDIT_REFERENCE_RATES_ROUTE,
  FETCH_PREVIOUS_INQUIRIES_FOR_RATE_PARAMETERS,
  INQUIRY_CREATE_NEGOTIATION,
  BOOKING_VIEW_BREAKDOWN_DOWNLOAD,
  FETCH_STRATEGIC_FFS,
  REJECT_INQUIRY_FF,
  REJECTED_INQUIRY_FF,
  FETCH_STRATEGIC_TRUCKERS,
  PREFILL_TRAILER_LOCATION_DETAILS,
  GET_LINKED_SHIPPERS,
  GET_RANK1_PRICE,
  GET_DROPDOWN_CHARGE_FOR_BIDS,
  BROADCAST_MESSAGE_INQUIRY,
  INQUIRY_GET_CREATOR_USERS,
  INQUIRY_GET_CREATOR_ORGS
} from './routes';
import { API_BASE_URL } from 'src/globals';
import { getAuthenticationHeaders, getErrorMessage, getErrorMessageForBlob } from './utils';
import apiProvider from './provider';
import { ApiResponseWrapper, GET, POST } from './apiHandler';
import ApiDto from 'src/dto/ApiDto';
import { APIResponseType } from 'src/Library/Types';
import { AxiosResponse, CancelTokenSource } from 'axios';

export const fetchRecentInquiryBidsForFF = async (body) => {
  try {
    const response = await apiProvider.post(
      `${API_BASE_URL}${INQUIRY_FETCH_RECENT_INQUIRY_BIDS_FOR_FF}`,
      body,
      { headers: getAuthenticationHeaders() }
    );
    return {
      isSuccess: true,
      data: response.data.data,
    };
  } catch (err) {
    const errorMessage = getErrorMessage(err);
    return {
      errorMessage,
      isSuccess: false,
    };
  }
};
export const getBidMasterForInquiry = async (params) => {
  try {
    const response: AxiosResponse<ApiResponseWrapper> = await apiProvider.get(`${API_BASE_URL}${INQUIRY_GET_BID_MASTER_FOR_INQUIRY}`, {
      params,
      headers: getAuthenticationHeaders(),
    });
    return {
      isSuccess: true,
      data: response.data.data,
    };
  } catch (err) {
    const errorMessage = getErrorMessage(err);
    return {
      errorMessage,
      isSuccess: false,
    };
  }
};
export const getInquiryCreators = async (params): Promise<{
  isSuccess: boolean;
  data?: { id: string; name: string }[];
  errorMessage?: string;
}> => {
  try {
    const response: AxiosResponse<ApiResponseWrapper<any>> = await apiProvider.get(`${API_BASE_URL}${INQUIRY_GET_CREATOR_USERS}`, {
      params,
      headers: getAuthenticationHeaders(),
    });
    return {
      isSuccess: true,
      data: response.data.data,
    };
  }
  catch (err) {
    const errorMessage = getErrorMessage(err);
    return {
      errorMessage,
      isSuccess: false,
    };
  }
}

export const getInquiryCreatorOrgs = async (params?: { queryString: string }): Promise<{
  isSuccess: boolean;
  data?: { organisationId: string; organisationName: string; internalId: string }[];
  errorMessage?: string;
}> => {
  try {
    const response: AxiosResponse<ApiResponseWrapper<any>> = await apiProvider.get(`${API_BASE_URL}${INQUIRY_GET_CREATOR_ORGS}`, {
      params,
      headers: getAuthenticationHeaders(),
    });
    return {
      isSuccess: true,
      data: response.data.data,
    };
  } catch (err) {
    const errorMessage = getErrorMessage(err);
    return {
      errorMessage,
      isSuccess: false,
    };
  }
}
export const getInquiryMasterData = async () => {
  try {
    const response: any = await apiProvider.get(`${API_BASE_URL}${INQUIRY_GET_MASTER_DATA}`, {
      headers: getAuthenticationHeaders(),
    });
    return {
      isSuccess: true,
      data: response.data.data,
    };
  } catch (error) {
    const errorMessage = getErrorMessage(error);
    return {
      errorMessage,
      isSuccess: false,
    };
  }
};

export const getExchangeRate = async (body) => {
  try {
    const response: any = await apiProvider.post(
      `${API_BASE_URL}${INQUIRY_GET_EXCHANAGE_RATE}`,
      body,
      { headers: getAuthenticationHeaders() }
    );
    return {
      isSuccess: true,
      data: response.data.data,
    };
  } catch (error) {
    const errorMessage = getErrorMessage(error);
    return {
      errorMessage,
      isSuccess: false,
    };
  }
};
export const updateExchangeRate = async (params) => {
  try {
    const response: any = await apiProvider.post(`${API_BASE_URL}${INQUIRY_UPDATE_EXCHANGE_RATE}`, {
      params,
      headers: getAuthenticationHeaders(),
    });
    return {
      isSuccess: true,
      data: response.data.data,
    };
  } catch (error) {
    const errorMessage = getErrorMessage(error);
    return {
      errorMessage,
      isSuccess: false,
    };
  }
};
export const createInquiry = async (body) => {
  try {
    const response = await apiProvider.post(`${API_BASE_URL}${INQUIRY_CREATE_INQUERY}`, body, {
      headers: getAuthenticationHeaders(),
    });
    return {
      isSuccess: true,
      data: response.data.data,
    };
  } catch (err) {
    const errorMessage = getErrorMessage(err);
    return {
      errorMessage,
      isSuccess: false,
    };
  }
};
export const updateInquiry = async (body) => {
  try {
    const response = await apiProvider.post(`${API_BASE_URL}${INQUIRY_UPDATE_INQUERY}`, body, {
      headers: getAuthenticationHeaders(),
    });
    return {
      isSuccess: true,
      data: response.data.data,
    };
  } catch (err) {
    const errorMessage = getErrorMessage(err);
    return {
      errorMessage,
      isSuccess: false,
    };
  }
};
export const searchInquiryForFFApi = async (val, source?: CancelTokenSource) => {
  try {
    const response = await apiProvider.post(
      `${API_BASE_URL}${INQUIRY_SEARCH_INQUIRY_FOR_FF}`,
      val,
      {
        headers: getAuthenticationHeaders(),
        ...(source ? { cancelToken: source.token } : {}),
      }
    );
    return {
      isSuccess: true,
      response: response.data.data,
    };
  } catch (err) {
    const errorMessage = getErrorMessage(err);
    return {
      errorMessage,
      isSuccess: false,
    };
  }
};
export const searchInquiryForShipperApi = async (val, source?: CancelTokenSource) => {
  try {
    const response = await apiProvider.post(
      `${API_BASE_URL}${INQUIRY_SEARCH_INQUIRY_FOR_SHIPPER}`,
      val,
      {
        headers: getAuthenticationHeaders(),
        ...(source ? { cancelToken: source.token } : {}),
      },
    );
    return {
      isSuccess: true,
      response: response.data.data,
    };
  } catch (err) {
    const errorMessage = getErrorMessage(err);
    return {
      errorMessage,
      isSuccess: false,
    };
  }
};
export const sendInquiry = async (params) => {
  try {
    const response = await apiProvider.post(`${API_BASE_URL}${INQUIRY_SEND_INQUIRY}`, params, {
      headers: getAuthenticationHeaders(),
    });
    return {
      isSuccess: true,
      response: response.data.data,
    };
  } catch (err) {
    const errorMessage = getErrorMessage(err);
    return {
      errorMessage,
      isSuccess: false,
    };
  }
};

export const sendBulkInquiry = async (params) => {
  return POST(`${API_BASE_URL}${SEND_BULK_INQUIRY}`, params);
}

export const getBidRanksShipperInquiry = async (params) => {
  try {
    const response = await apiProvider.post(
      `${API_BASE_URL}${INQUIRY_GET_BID_RANKS_FOR_SHIPPER}`,
      params,
      { headers: getAuthenticationHeaders() }
    );
    return {
      isSuccess: true,
      data: response.data.data,
    };
  } catch (err) {
    const errorMessage = getErrorMessage(err);
    return {
      errorMessage,
      isSuccess: false,
    };
  }
};

export const getBidRanksFFInquiry = async (params) => {
  try {
    const response = await apiProvider.post(
      `${API_BASE_URL}${INQUIRY_GET_BID_RANKS_FOR_FF}`,
      params,
      { headers: getAuthenticationHeaders() }
    );
    return {
      isSuccess: true,
      data: response.data.data,
    };
  } catch (err) {
    const errorMessage = getErrorMessage(err);
    return {
      errorMessage,
      isSuccess: false,
    };
  }
};

export const extendBidDeadline = async (body) => {
  try {
    const response = await apiProvider.post(
      `${API_BASE_URL}${INQUIRY_EXETEND_DEADLINE_FOR_BID}`,
      body,
      { headers: getAuthenticationHeaders() }
    );
    return {
      isSuccess: true,
      response: response.data.data,
    };
  } catch (err) {
    const errorMessage = getErrorMessage(err);
    return {
      errorMessage,
      isSuccess: false,
    };
  }
};

export const updateInquiryDeadLine = async (params) => {
  try {
    const response = await apiProvider.post(`${API_BASE_URL}${INQUIRY_UPDATE_DEADLINE}`, params, {
      headers: getAuthenticationHeaders(),
    });
    return {
      isSuccess: true,
      response: response.data.data,
    };
  } catch (err) {
    const errorMessage = getErrorMessage(err);
    return {
      errorMessage,
      isSuccess: false,
    };
  }
};

export const updateBulkInquiryDeadline = async (params) => {
  try {
      return POST(`${API_BASE_URL}${BULK_INQUIRY_DEADLINE_UPDATE}`, params);
  } catch (err) {
    const errorMessage = getErrorMessage(err);
    return {
      errorMessage,
      isSuccess: false,
    };
  }
}

export const fetchInquiryDetailsForShipper = async (params) => {
  try {
    const response: AxiosResponse<ApiResponseWrapper<any>> = await apiProvider.get(
      `${API_BASE_URL}${INQUIRY_FETCH_INQUIRY_SHIPPER_DETAILS}`,
      {
        params,
        headers: getAuthenticationHeaders(),
      }
    );
    return {
      isSuccess: true,
      data: response.data.data,
    };
  } catch (err) {
    const errorMessage = getErrorMessage(err);
    return {
      errorMessage,
      isSuccess: false,
    };
  }
};

export const fetchInquiryDetailsForFF = async (params) => {
  try {
    const response: AxiosResponse<ApiResponseWrapper> = await apiProvider.get(
      `${API_BASE_URL}${INQUIRY_FETCH_INQUIRY_DETAILS_FOR_FF}`,
      {
        params,
        headers: getAuthenticationHeaders(),
      }
    );
    return {
      isSuccess: true,
      data: response.data.data,
    };
  } catch (err) {
    const errorMessage = getErrorMessage(err);
    return {
      errorMessage,
      isSuccess: false,
    };
  }
};

export const fetchAllEnquiries = async (params) => {
  try {
    const response = await apiProvider.post(
      `${API_BASE_URL}${INQUIRY_FETCH_ALL_FF_INQUIRIES}`,
      params,
      { headers: getAuthenticationHeaders() }
    );
    return {
      isSuccess: true,
      response: response.data.data,
    };
  } catch (err) {
    const errorMessage = getErrorMessage(err);
    return {
      errorMessage,
      isSuccess: false,
    };
  }
};
export const fetchAllShipperEnquiries = async (params) => {
  try {
    const response = await apiProvider.post(
      `${API_BASE_URL}${INQUIRY_FETCH_ALL_SHIPPER_INQUIRIES}`,
      params,
      { headers: getAuthenticationHeaders() }
    );
    return {
      isSuccess: true,
      response: response.data.data,
    };
  } catch (err) {
    const errorMessage = getErrorMessage(err);
    return {
      errorMessage,
      isSuccess: false,
    };
  }
};
export const fetchAllInquriesForFF = async (params) => {
  try {
    const response = await apiProvider.post(
      `${API_BASE_URL}${INQUIRY_FETCH_ALL_FF_INQUIRIES}`,
      params,
      { headers: getAuthenticationHeaders() }
    );
    return {
      isSuccess: true,
      response: response.data.data,
    };
  } catch (err) {
    const errorMessage = getErrorMessage(err);
    return {
      errorMessage,
      isSuccess: false,
    };
  }
};

export const fetchInquiryStatusWiseCountForShipper = async (params) => {
  try {
    const response = await apiProvider.post(
      `${API_BASE_URL}${INQUIRY_FETCH_STATUS_WISE_COUNT_FOR_SHIPPER_INQUIRIES}`,
      params,
      { headers: getAuthenticationHeaders() }
    );
    return {
      isSuccess: true,
      response: response.data.data,
    };
  } catch (err) {
    const errorMessage = getErrorMessage(err);
    return {
      errorMessage,
      isSuccess: false,
    };
  }
};

export const fetchInquiryStatusWiseCountForFF = async (params) => {
  try {
    const response = await apiProvider.post(
      `${API_BASE_URL}${INQUIRY_FETCH_STATUS_WISE_COUNT_FOR_FF_INQUIRIES}`,
      params,
      { headers: getAuthenticationHeaders() }
    );
    return {
      isSuccess: true,
      response: response.data.data,
    };
  } catch (err) {
    const errorMessage = getErrorMessage(err);
    return {
      errorMessage,
      isSuccess: false,
    };
  }
};

export const fetchAllShipperBidsInquiry = async (params) => {
  try {
    const response = await apiProvider.post(
      `${API_BASE_URL}${INQUIRY_FETCH_ALL_BIDS_SHIPPER_INQUIRY}`,
      params,
      { headers: getAuthenticationHeaders() }
    );
    return {
      isSuccess: true,
      data: response.data.data,
    };
  } catch (err) {
    const errorMessage = getErrorMessage(err);
    return {
      errorMessage,
      isSuccess: false,
    };
  }
};
export const fetchAllFFBidsInquiry = async (params) => {
  try {
    const response = await apiProvider.post(
      `${API_BASE_URL}${INQUIRY_FETCH_ALL_BIDS_FF_INQUIRY}`,
      params,
      { headers: getAuthenticationHeaders() }
    );
    return {
      isSuccess: true,
      data: response.data,
    };
  } catch (err) {
    const errorMessage = getErrorMessage(err);
    return {
      errorMessage,
      isSuccess: false,
    };
  }
};
export const sendBid = async (params) => {
  try {
    const response = await apiProvider.post(
      `${API_BASE_URL}${INQUIRY_SEND_BID_FOR_INQUIRY}`,
      params,
      { headers: getAuthenticationHeaders() }
    );
    return {
      isSuccess: true,
      response: response.data.data,
    };
  } catch (err) {
    const errorMessage = getErrorMessage(err);
    return {
      errorMessage,
      isSuccess: false,
    };
  }
};
export const createBidForInquiryApi = async ({ userType, apiCallObject }) => {
  try {
    const response = await apiProvider.post(
      `${API_BASE_URL}${
        userType === 'FF' ? INQUIRY_CREATE_BID_FOR_INQUIRY : INQUIRY_CREATE_BID_SHIPPER
      }`,
      apiCallObject,
      { headers: getAuthenticationHeaders() }
    );
    return {
      isSuccess: true,
      response: response.data.data,
    };
  } catch (err) {
    const errorMessage = getErrorMessage(err);
    return {
      errorMessage,
      isSuccess: false,
    };
  }
};

export const confirmBid = async (params) => {
  try {
    const response = await apiProvider.post(
      `${API_BASE_URL}${INQUIRY_CONFIRM_BID_FOR_INQUIRY}`,
      params,
      { headers: getAuthenticationHeaders() }
    );
    return {
      isSuccess: true,
      response: response.data.data,
    };
  } catch (err) {
    const errorMessage = getErrorMessage(err);
    return {
      errorMessage,
      isSuccess: false,
    };
  }
};

export const declineBid = async (params) => {
  try {
    const response = await apiProvider.post(
      `${API_BASE_URL}${INQUIRY_DECLINE_BID_FOR_INQUIRY}`,
      params,
      { headers: getAuthenticationHeaders() }
    );
    return {
      isSuccess: true,
      response: response.data.data,
    };
  } catch (err) {
    const errorMessage = getErrorMessage(err);
    return {
      errorMessage,
      isSuccess: false,
    };
  }
};

export const deleteBidForShipper = async (bidId, deletionReason) => {
  try {
    const response = await apiProvider.post(
      `${API_BASE_URL}${INQUIRY_DELETE_BID_FOR_SHIPPER}`,
      { bidId, deletionReason },
      { headers: getAuthenticationHeaders() }
    );
    return {
      isSuccess: true,
      data: response,
    };
  } catch (err) {
    const errorMessage = getErrorMessage(err);
    return {
      errorMessage,
      isSuccess: false,
    };
  }
};

export const updateBidForInquiry = async (body) => {
  try {
    const response = await apiProvider.post(
      `${API_BASE_URL}${INQUIRY_UPDATE_BID_FOR_INQUIRY}`,
      body,
      { headers: getAuthenticationHeaders() }
    );
    return {
      isSuccess: true,
      data: response.data.data,
    };
  } catch (err) {
    const errorMessage = getErrorMessage(err);
    return {
      errorMessage,
      isSuccess: false,
    };
  }
};

export const getBidDetailsFFApi = async (params) => {
  try {
    const response: AxiosResponse<ApiResponseWrapper> = await apiProvider.get(`${API_BASE_URL}${INQUIRY_FF_VIEW_BREAKDOWN}`, {
      params,
      headers: getAuthenticationHeaders(),
    });
    return {
      isSuccess: true,
      data: response.data.data,
    };
  } catch (err) {
    const errorMessage = getErrorMessage(err);
    return {
      errorMessage,
      isSuccess: false,
    };
  }
};
export const viewBreakDownForShipper = async (params) => {
  try {
    const response: AxiosResponse<ApiResponseWrapper> = await apiProvider.get(`${API_BASE_URL}${INQUIRY_SHIPPER_VIEW_BREAKDOWN}`, {
      params,
      headers: getAuthenticationHeaders(),
    });
    return {
      isSuccess: true,
      data: response.data.data,
    };
  } catch (err) {
    const errorMessage = getErrorMessage(err);
    return {
      errorMessage,
      isSuccess: false,
    };
  }
};

export const deleteInquiry = async (body) => {
  try {
    const response = await apiProvider.post(`${API_BASE_URL}${INQUIRY_DELETE_INQUIRY}`, body, {
      headers: getAuthenticationHeaders(),
    });
    return {
      isSuccess: true,
      data: response,
    };
  } catch (err) {
    const errorMessage = getErrorMessage(err);
    return {
      errorMessage,
      isSuccess: false,
    };
  }
};
export const getBidChargesApi = async (body) => {
  try {
    const response = await apiProvider.post(`${API_BASE_URL}${INQUIRY_FETCH_BID_CHARGES}`, body, {
      headers: getAuthenticationHeaders(),
    });
    return {
      isSuccess: true,
      data: response.data.data,
    };
  } catch (err) {
    const errorMessage = getErrorMessage(err);
    return {
      errorMessage,
      isSuccess: false,
    };
  }
};

export const deleteBidsForInquiry = async (body) => {
  try {
    const response = await apiProvider.post(`${API_BASE_URL}${INQUIRY_DELETE_BID}`, body, {
      headers: getAuthenticationHeaders(),
    });
    return {
      isSuccess: true,
      data: response.data,
    };
  } catch (err) {
    const errorMessage = getErrorMessage(err);
    return {
      errorMessage,
      isSuccess: false,
    };
  }
};

export const downloadBidsForShipper = async (body) => {
  try {
    let response;
    response = await apiProvider.post(`${API_BASE_URL}${INQUIRY_DOWNLOAD_BIDS_SHIPPER}`, body, {
      headers: getAuthenticationHeaders(),
      responseType: 'blob',
    });
    const disposition = response.headers['content-disposition'];
    let filename = '';
    if (disposition) {
      const matches = disposition.match(/filename="(.*)"/);
      filename = matches && matches.length && matches.length > 0 ? decodeURI(matches[1]) : '';
    }
    return {
      filename,
      isSuccess: true,
      data: response.data,
      contentType: response.headers['content-type'],
    };
  } catch (error) {
    const errorMessage = error?.response?.status === 503
      ? 'PDF service is temporarily unavailable. Please try again later.'
      : await getErrorMessageForBlob(error);
    return {
      errorMessage,
      isSuccess: false,
    };
  }
};

export const downloadBidsForFF = async (body) => {
  try {
    let response;
    response = await apiProvider.post(`${API_BASE_URL}${INQUIRY_DOWNLOAD_BIDS_FF}`, body, {
      headers: getAuthenticationHeaders(),
      responseType: 'blob',
    });
    const disposition = response.headers['content-disposition'];
    let filename = '';
    if (disposition) {
      const matches = disposition.match(/filename="(.*)"/);
      filename = matches && matches.length && matches.length > 0 ? decodeURI(matches[1]) : '';
    }
    return {
      filename,
      isSuccess: true,
      data: response.data,
      contentType: response.headers['content-type'],
    };
  } catch (error) {
    const errorMessage = error?.response?.status === 503
      ? 'PDF service is temporarily unavailable. Please try again later.'
      : await getErrorMessageForBlob(error);
    return {
      errorMessage,
      isSuccess: false,
    };
  }
};

export const getInquiryDetailsForBidApi = async (params) => {
  try {
    const response: AxiosResponse<ApiResponseWrapper<any>> = await apiProvider.get(`${API_BASE_URL}${GET_INQUIRY_DETAILS_FOR_BID}`, {
      params,
      headers: getAuthenticationHeaders(),
    });
    return {
      isSuccess: true,
      data: response.data.data,
    };
  } catch (err) {
    const errorMessage = getErrorMessage(err);
    return {
      errorMessage,
      isSuccess: false,
    };
  }
};
export const fileUploadOnS3 = async (body) => {
  try {
    const response = await apiProvider.post(`${API_BASE_URL}${GET_S3_UPLOAD_LINKS}`, body, {
      headers: getAuthenticationHeaders(),
    });
    return {
      isSuccess: true,
      data: response.data.data,
    };
  } catch (err) {
    const errorMessage = getErrorMessage(err);
    return {
      errorMessage,
      isSuccess: false,
    };
  }
};

export const fetchInquirySummaryForShipper = async (params) => {
  try {
    const response: AxiosResponse<ApiResponseWrapper> = await apiProvider.get(`${API_BASE_URL}${FETCH_INQUIRY_SUMMARY_FOR_SHIPPER}`, {
      params,
      headers: getAuthenticationHeaders(),
    });
    return {
      isSuccess: true,
      data: response.data,
    };
  } catch (err) {
    const errorMessage = getErrorMessage(err);
    return {
      errorMessage,
      isSuccess: false,
    };
  }
};

export const getInquiryMISReport = async () => {
  try {
    const response: AxiosResponse<ApiResponseWrapper<any>> = await apiProvider.get(`${API_BASE_URL}${INQUIRY_MIS_REPORTS}`, {
      headers: getAuthenticationHeaders(),
    });
    return {
      isSuccess: true,
      response: response.data.data,
    };
  } catch (err) {
    const errorMessage = getErrorMessage(err);
    return {
      errorMessage,
      isSuccess: false,
    };
  }
};

export const downloadViewBreakdown = async (body) => {
  try {
    let response;
    response = await apiProvider.post(`${API_BASE_URL}${VIEW_BREAKDOWN_DOWNLOAD}`, body, {
      headers: getAuthenticationHeaders(),
      responseType: 'blob',
    });
    const disposition = response.headers['content-disposition'];
    let filename = '';
    if (disposition) {
      const matches = disposition.match(/filename=\"(.*)\"/);
      filename = matches && matches.length && matches.length > 0 ? decodeURI(matches[1]) : '';
    }
    return {
      filename,
      isSuccess: true,
      data: response.data,
      contentType: response.headers['content-type'],
    };
  } catch (error) {
    const errorMessage = await getErrorMessageForBlob(error);
    return {
      errorMessage,
      isSuccess: false,
    };
  }
};

export const downloadSampleInquiry = async (params) => {
  try {
    const response = await apiProvider.get(`${API_BASE_URL}${DOWNLOAD_SAMPLE_INQUIRY}`, {
      params,
      headers: getAuthenticationHeaders(),
      responseType: 'blob',
    });
    const disposition = response.headers['content-disposition'];
    let filename = '';
    if (disposition) {
      const matches = disposition.match(/filename="(.*)"/);
      filename = matches && matches.length && matches.length > 0 ? decodeURI(matches[1]) : '';
    }
    return {
      filename,
      isSuccess: true,
      data: response.data,
    };
  } catch (error) {
    const errorMessage = await getErrorMessageForBlob(error);
    return {
      errorMessage,
      isSuccess: false,
    };
  }
};

export const downloadSampleBids = async (params) => {
  try {
    const response = await apiProvider.get(`${API_BASE_URL}${DOWNLOAD_SAMPLE_BIDS}`, {
      params,
      headers: getAuthenticationHeaders(),
      responseType: 'blob',
    });
    const disposition = response.headers['content-disposition'];
    let filename = '';
    if (disposition) {
      const matches = disposition.match(/filename="(.*)"/);
      filename = matches && matches.length && matches.length > 0 ? decodeURI(matches[1]) : '';
    }
    return {
      filename,
      isSuccess: true,
      data: response.data,
    };
  } catch (error) {
    const errorMessage = await getErrorMessageForBlob(error);
    return {
      errorMessage,
      isSuccess: false,
    };
  }
};

export const fetchBulkBidHeaderMapping = async (params) => {
  try {
    const response = await apiProvider.post(
      `${API_BASE_URL}${FETCH_BULK_BID_HEADER_MAPPING}`,
      params,
      {
        headers: getAuthenticationHeaders(),
      }
    );
    return {
      isSuccess: true,
      data: response.data,
    };
  } catch (err) {
    const errorMessage = getErrorMessage(err);
    return {
      errorMessage,
      isSuccess: false,
    };
  }
};

export const bulkInquiryCreation = async (body, mode) => {
  try {
    const ENDPOINT = BULK_INQUIRY_CREATION_ENDPOINT.replace('{mode}', mode);
    const response = await POST(`${API_BASE_URL}${ENDPOINT}`, body)
    
    return response;
  } catch (error) {
    const errorMessage = getErrorMessage(error);
    return {
      errorMessage,
      isSuccess: false,
    };
  }
};

export const uploadBulkBids = async (params) => {
  try {
    const response = await apiProvider.post(`${API_BASE_URL}${INQUIRY_UPLOAD_BULK_BIDS}`, params, {
      headers: getAuthenticationHeaders(),
    });
    return {
      isSuccess: true,
      data: response.data.data,
    };
  } catch (error) {
    const errorMessage = getErrorMessage(error);
    return {
      errorMessage,
      isSuccess: false,
    };
  }
};

export const fetchLinkedFFsForInquiry = async (body) => {
  try {
    const response = await apiProvider.post(
      `${API_BASE_URL}${FETCH_LINKED_FFS_FOR_INQUIRY}`,
      body,
      { headers: getAuthenticationHeaders() }
    );
    return {
      isSuccess: true,
      data: response.data.data,
    };
  } catch (error) {
    const errorMessage = getErrorMessage(error);
    return {
      errorMessage,
      isSuccess: false,
    };
  }
};

export const downloadSampleBidsShipper = async (params) => {
  try {
    const response = await apiProvider.get(`${API_BASE_URL}${DOWNLOAD_SAMPLE_BIDS_SHIPPER}`, {
      params,
      headers: getAuthenticationHeaders(),
      responseType: 'blob',
    });
    const disposition = response.headers['content-disposition'];
    let filename = '';
    if (disposition) {
      const matches = disposition.match(/filename="(.*)"/);
      filename = matches && matches.length && matches.length > 0 ? decodeURI(matches[1]) : '';
    }
    return {
      filename,
      isSuccess: true,
      data: response.data,
    };
  } catch (error) {
    const errorMessage = await getErrorMessageForBlob(error);
    return {
      errorMessage,
      isSuccess: false,
    };
  }
};

export const uploadBulkBidsShipper = async (params) => {
  try {
    const response = await apiProvider.post(
      `${API_BASE_URL}${INQUIRY_UPLOAD_BULK_BIDS_SHIPPER}`,
      params,
      { headers: getAuthenticationHeaders() }
    );
    return {
      isSuccess: true,
      data: response.data.data,
    };
  } catch (error) {
    const errorMessage = getErrorMessage(error);
    return {
      errorMessage,
      isSuccess: false,
    };
  }
};

export const getAllChargesForBulkBidsUpload = async (params: { shipperId: string}) : Promise<
APIResponseType<typeof ApiDto.GetAllChargesForBulkBidsUploadResponseDTO>
> => {
return GET(`${API_BASE_URL}${GET_ALL_CHARGES_FOR_BULK_BIDS_UPLOAD}`, params);
};

export const editAccessInInquiryDetails = async (params) => {
  try {
    const response = await apiProvider.patch(
      `${API_BASE_URL}${EDIT_ACCESS_INQUIRY_DETAILS}`,
      params,
      {
        headers: getAuthenticationHeaders(),
      }
    );
    return {
      isSuccess: true,
      data: response.data.data,
    };
  } catch (error) {
    const errorMessage = getErrorMessage(error);
    return {
      errorMessage,
      isSuccess: false,
    };
  }
};

export const getInternalReferenceNumberList = async (params) => {
  return await GET(`${API_BASE_URL}${INQUIRY_SEARCH_INTERNAL_REFERENCE}`, params);
};

export const resetReferenceRateNotification = async (params) => {
  return POST(`${API_BASE_URL}${RESET_REFERENCE_RATE_NOTIFICATION_ROUTE}`, params);
};

export const fetchBidRevisionHistory = async (baseRevisionBidId, type) => {
  return await GET(
    `${API_BASE_URL}${type === 'SHIPPER' ? INQUIRY_BID_REVISION_SHIPPER : INQUIRY_BID_REVISION_FF}`,
    {
      baseRevisionBidId,
    }
  );
};

export const fetchLowestBid = async (params) => {
  return POST(`${API_BASE_URL}${FETCH_LOWEST_BID_ROUTE}`, params);
};

export const updateReferenceRate = async (params) => {
  return POST(`${API_BASE_URL}${EDIT_REFERENCE_RATES_ROUTE}`, params);
};

export const fetchPreviousInquiries = async (params) => {
  return POST(`${API_BASE_URL}${FETCH_PREVIOUS_INQUIRIES_FOR_RATE_PARAMETERS}`, params);
};

export const inquiryCreateNegotiation = async (params) => {
  return POST(`${API_BASE_URL}${INQUIRY_CREATE_NEGOTIATION}`, params);
};

export const downloadBookingViewBreakdown = async (params) => {
  return POST(
    `${API_BASE_URL}${BOOKING_VIEW_BREAKDOWN_DOWNLOAD}`,
    params,
    getAuthenticationHeaders(),
    true
  );
};

export const fetchStrategicFFs = async () => {
  return GET(`${API_BASE_URL}${FETCH_STRATEGIC_FFS}`);
};

export const rejectInquiryFF = async (params) => {
  return POST(`${API_BASE_URL}${REJECT_INQUIRY_FF}`, params);
};

export const fetchRejectedFFs = async (inquiryId) => {
  return GET(`${API_BASE_URL}${REJECTED_INQUIRY_FF}/${inquiryId}`);
};

export const fetchStrategicTruckers = async () => {
  return GET(`${API_BASE_URL}${FETCH_STRATEGIC_TRUCKERS}`);
};

export const prefillTruckingLocationDetails = async () => {
  return GET(`${API_BASE_URL}${PREFILL_TRAILER_LOCATION_DETAILS}`);
};

export const getLinkedShippers = async (queryString) => {
  return GET(`${API_BASE_URL}${GET_LINKED_SHIPPERS}`, queryString);
};

export const getRank1Price = async (id) => {
  return GET(`${API_BASE_URL}${GET_RANK1_PRICE}/${id}/rank1-price-per-unit`);
};

export const getDropdownChargeforBids = async (queryString) => {
  return GET(`${API_BASE_URL}${GET_DROPDOWN_CHARGE_FOR_BIDS}`, queryString)
}

export const postBroadcastMessage = async (params) => {
  return POST(`${API_BASE_URL}${BROADCAST_MESSAGE_INQUIRY}`, params);
}
